import type { AnyAction, ReducersMapObject } from "redux";

import { applicationReducer } from "./applications";
import { authReducer } from "./auth";
import { connectionReducer } from "./connection";
import { deletedDeviceReducer } from "./deleted-devices/reducers";
import { deviceStatusReducer } from "./device-statuses";
import { deviceReducer } from "./devices";
import { devicesLastSeenReducer } from "./last-seen-devices/reducers";
import { loaderReducer } from "./loader";
import { messagesReducer } from "./messages";
import { networkReducer } from "./networks";
import { userContentsReducer } from "./user-contents/reducers";
import { usersReducer } from "./users";

const globalReducers: ReducersMapObject<unknown, AnyAction> = {
  applications: applicationReducer,
  auth: authReducer,
  connection: connectionReducer,
  deletedDevices: deletedDeviceReducer,
  devices: deviceReducer,
  devicesLastSeen: devicesLastSeenReducer,
  deviceStatuses: deviceStatusReducer,
  loader: loaderReducer,
  messages: messagesReducer,
  networks: networkReducer,
  userContents: userContentsReducer,
  users: usersReducer,
};

export { globalReducers };
